<template>
  <VDialogV3
    id="receipt-position-dialog"
    position="right"
    width="600px"
    height="100vh"
    not-hide-on-click
    :entity="localPosition"
    @submit="onSubmit"
  >
    <template #header>
      <template v-if="position">
        <div class="title">
          {{ localPosition.toString() }}
        </div>

        <VBadges>
          <VBadge
            v-if="localPosition.hasComplaint"
            class="warning"
          >
            Есть претензия
          </VBadge>
        </VBadges>
      </template>
    </template>

    <section>
      <header>Товар</header>

      <VInput
        label="Название"
        layout="vertical"
        disabled
        :value="localPosition.orderPosition.name"
      />

      <VInput
        label="Артикул"
        layout="vertical"
        disabled
        :value="localPosition.orderPosition.buyersCode || '--'"
      />

      <VInputNumberRusV2
        label="Количество"
        layout="vertical"
        :model-value="localPosition.shipmentPosition.qty"
        :type="Qty"
        disabled
        :unit="localPosition.orderPosition.unit?.name"
      />
    </section>

    <hr>

    <section class="receipt">
      <header>
        <span>Приемка</span>
      </header>

      <VInputNumberRusV2
        label="Отгружено"
        layout="vertical"
        :model-value="localPosition.shipmentPosition.qty"
        :type="Qty"
        disabled
        :unit="localPosition.orderPosition.unit"
      />

      <VInputNumberRusV2
        label="Получено"
        layout="vertical"
        :model-value="localPosition.qty"
        :type="Qty"
        required
        autocomplete="off"
        :min="0"
        :unit="localPosition.orderPosition.unit"
        @update:model-value="(qty) => localPosition.setReceivedQty(qty)"
      />
    </section>

    <hr>

    <section class="complaints">
      <header>
        <span>Расхождения</span>
      </header>

      <VInputNumberRusV2
        label="Недостача"
        layout="vertical"
        :model-value="localPosition.getComplaintQty('shortage')"
        :type="Qty"
        autocomplete="off"
        :min="0"
        @update:model-value="(qty) => localPosition.setComplaintQty('shortage', qty)"
        :unit="localPosition.orderPosition.unit"
      />

      <VInputNumberRusV2
        label="Некондиция"
        layout="vertical"
        :model-value="localPosition.getComplaintQty('nonstandard')"
        :type="Qty"
        autocomplete="off"
        :min="0"
        @update:model-value="(qty) => localPosition.setOtherComplaintQty('nonstandard', qty)"
        :unit="localPosition.orderPosition.unit"
      />

      <VInputNumberRusV2
        label="Неверная упаковка"
        layout="vertical"
        :model-value="localPosition.getComplaintQty('poorPackaging')"
        :type="Qty"
        autocomplete="off"
        :min="0"
        @update:model-value="(qty) => localPosition.setOtherComplaintQty('poorPackaging', qty)"
        :unit="localPosition.orderPosition.unit"
      />

      <VInputNumberRusV2
        label="Излишек"
        layout="vertical"
        :model-value="localPosition.getComplaintQty('excess')"
        :type="Qty"
        autocomplete="off"
        :min="0"
        @update:model-value="(qty) => localPosition.setOtherComplaintQty('excess', qty)"
        :unit="localPosition.orderPosition.unit"
      />
    </section>
  </VDialogV3>
</template>

<script lang="ts">

import type ReceiptPosition          from '@/domains/Receipts/ReceiptPosition';
import type Shipment                 from '@/domains/Shipments/Shipment';

import Qty                           from '@/core/types/Qty';

export default defineComponent({
  name: 'ReceiptPositionDialog',

  props: {
    position: {
      type:     Object as PropType<ReceiptPosition>,
      required: true,
    },
    shipment: {
      type:    Object as () => Shipment | null,
      default: null,
    },
  },

  emits: ['save'],

  setup() {
    return {
      Qty,
    };
  },

  data() {
    return {
      localPosition: this.$core.utils.cloneDeepWithReference(this.position, ['shipmentPosition', 'orderPosition']) as ReceiptPosition,
    };
  },

  methods: {
    onSubmit(): void {
      this.$emit('save', this.localPosition);
      this.$core.dialogs.ReceiptPositionDialog.hide();
    },
  },
});
</script>
